<template>
  <div id="supportConfirm">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'arrow_flow2'"
          />
          <section>
            <h1>お問い合わせ内容確認</h1>
            <div class="confirm_area">
              <div class="input_confirm">
                <ul>
                  <li>
                    {{label.supportType}}：{{supportData.supportType.label}}
                  </li>
                  <li>
                    {{label.supportMaker}}：{{supportData.supportMaker ? supportData.supportMaker.label : ''}}
                  </li>
                  <li>
                    {{label.supportTitle}}：{{supportData.supportTitle}}
                  </li>
                  <li>
                    {{label.supportBody}}：{{supportData.supportBody}}
                  </li>
                  <li>
                    {{label.userName}}：{{supportData.userLastName}} {{supportData.userFirstName}}
                  </li>
                  <li>
                    {{label.userNameKana}}：{{supportData.userLastNameKana}} {{supportData.userFirstNameKana}}
                  <li>
                    {{label.email}}：{{supportData.email}}
                  </li>
                  <li>
                    {{label.tel}}：{{supportData.tel}}
                  </li>
                </ul>
              </div>
            </div>
            <div class="control_btn_area">
              <!-- <div>※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。</div> -->
              <div class="detail_btn5" @click="goBack()">〈〈 内容を修正する</div>
              <div class="detail_btn2" @click="complete()">お問い合わせを行う 〉〉</div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- <dd-image-viewer-model /> -->
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import DcFooter from '../components/common/DcFooter'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SupportConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'supportConfirm',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'supportInput', key: 'supportInput', title: 'お問い合わせ入力'},
        {id: 'supportConfirm', key: 'supportConfirm', title: 'お問い合わせ内容確認'},
        {id: 'supportComplete', key: 'supportComplete', title: 'お問い合わせ完了'}
      ],
      supportData: {},
      label: {
        supportType: '質問カテゴリ',
        supportMaker: 'お問い合わせメーカー',
        supportTitle: '件名',
        supportBody: '本文',
        userName: 'ご氏名',
        userNameKana: 'ご氏名（カナ）',
        email: 'ご連絡先メールアドレス',
        tel: 'お電話番号'
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    complete: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        supportType: this.supportData.supportType.code,
        supportMaker: this.supportData.supportMaker ? this.supportData.supportMaker.code : '',
        supportTitle: this.supportData.supportTitle ? this.supportData.supportTitle : '',
        supportBody: this.supportData.supportBody,
        userLastName: this.supportData.userLastName,
        userFirstName: this.supportData.userFirstName,
        userLastNameKana: this.supportData.userLastNameKana,
        userFirstNameKana: this.supportData.userFirstNameKana,
        email: this.supportData.email,
        tel: this.supportData.tel
      }

      axios.post(DC_URL.SUPPORT + '/complete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$router.push('/mmstyle/support/complete')
          }
        }).catch(error => {
          Api.handleError(error)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      if (this.$route.params.supportData) {
        this.supportData = this.$route.params.supportData
      } else {
        this.supportData = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSupportConfirm.vue